import React, { useEffect, useState } from 'react';
import RefundBreakdown from './refund-breakdown';
import Pictogram from '../pictogram';
import TranslatedCopy from '../../../intl/translated-copy';
import { HomeE4 } from '../../../../routing/urls';
import useWizard from '../wizard/useWizard';
import { formatAmountWithDecimals } from '../../../../cms-wrapper/utils';
import LoadingComponent from '../loading-component';
import RefundPenaltyChargePaid from './refund-penalty-charge-paid';

const RefundConfirmationViewMobile = ({
  breakpointNewDesign,
  cardNumbers,
  country,
  currencyOfRefund,
  date,
  language,
  numberOfDecimalsBE,
  optionSelected,
  refundInfoToSalesforce,
  specialRefund,
  storefront,
  total,
}) => {
  const { penaltyChargeCard, thereAreDTickets, nonRefundableExtrasExist } = useWizard();

  const decimals = numberOfDecimalsBE != null ? numberOfDecimalsBE : 0;

  const copyNote = optionSelected === 'AW' ? 'MYB_USE_YOUR_BALANCE' : 'MYB_REFUND_WILL_BE_REFLECTED_IN_DAYS';

  const [newTicketNumber, setNewTicketNumber] = useState(0);

  useEffect(() => {
    if (!refundInfoToSalesforce?.errorFromSalesforce && refundInfoToSalesforce?.messageServer?.casenumber !== '' && refundInfoToSalesforce?.messageServer?.casenumber !== undefined) {
      setNewTicketNumber(refundInfoToSalesforce?.messageServer?.casenumber);
    } else if (refundInfoToSalesforce?.errorFromSalesforce) {
      setNewTicketNumber('Error');
    }
  }, [refundInfoToSalesforce]);

  // Se hizo maquetado, actualmente no existe informacion real para asignar esto
  const showPoints = false;

  return (
    <>
      <div className='RefundConfirmationViewMobile-wrapper'>
        <div className='RefundConfirmationViewMobile-wrapper-confirmationHeader'>
          <Pictogram className='RefundConfirmationViewMobile-wrapper-confirmationHeader--confirmationIcon' id='RefundSuccessful' />
          <div className='RefundConfirmationViewMobile-wrapper-confirmationHeader-confirmationDetailsTextContainer'>
            <TranslatedCopy
              className='RefundConfirmationViewMobile-wrapper-confirmationHeader-confirmationDetailsTextContainer--header'
              copyID='MYB_REFUND_APPLIED'
              tagName='p'
            />
            <p className='RefundConfirmationViewMobile-wrapper-confirmationHeader-confirmationDetailsTextContainer--confirmationNumber'>Confirmación AM123456</p>
          </div>
        </div>
        <div className='RefundConfirmationViewMobile-wrapper-confirmationBody'>
          <div className='RefundConfirmationViewMobile-Body-confirmationViewUserDetails'>
            <div className='RefundConfirmationViewMobile-Body-confirmationViewUserDetails-secondWrapper'>
              { showPoints &&
                <>
                  <div className='RefundConfirmationViewMobile-secondWrapper-accountDetails'>
                    <div className='RefundConfirmationViewMobile-secondWrapper-accountDetails-account'>
                      <p className='RefundConfirmationViewMobile-secondWrapper-accountDetails-account-name'>
                      </p>
                      <Pictogram
                        className='RefundConfirmationViewMobile-secondWrapper-accountDetails-account-icon'
                        id='AerowalletWhiteBackground'
                      />
                    </div>
                    <div className='RefundConfirmationViewMobile-secondWrapper-accountDetails-preBalance'>
                      <TranslatedCopy
                        className='RefundConfirmationViewMobile-secondWrapper-accountDetails-preBalance-title'
                        copyID='MYB_PREVIOUS_BALANCE'
                        tagName='p'
                      />
                      <div className='RefundConfirmationViewMobile-secondWrapper-accountDetails-preBalance-pointsSection'>
                        <span className='RefundConfirmationViewMobile-secondWrapper-accountDetails-preBalance-pointsSection-amount'>{'0 '}</span>
                        <TranslatedCopy
                          className='RefundConfirmationViewMobile-secondWrapper-accountDetails-preBalance-pointsSection-pointsText'
                          copyID='MYB_POINTS_SELECT'
                          tagName='span'
                        />
                      </div>
                    </div>
                    <div className='RefundConfirmationViewMobile-secondWrapper-accountDetails-postBalance'>
                      <TranslatedCopy
                        className='RefundConfirmationViewMobile-secondWrapper-accountDetails-postBalance-title'
                        copyID='MYB_BALANCE_REFUNDED'
                        tagName='p'
                      />
                      <div className='RefundConfirmationViewMobile-secondWrapper-accountDetails-postBalance-pointsSection'>
                        <span className='RefundConfirmationViewMobile-secondWrapper-accountDetails-postBalance-pointsSection-amount'>{'0 '}</span>
                        <TranslatedCopy
                          className='RefundConfirmationViewMobile-secondWrapper-accountDetails-postBalance-pointsSection-pointsText'
                          copyID='MYB_POINTS_SELECT'
                          tagName='span'
                        />
                      </div>
                    </div>
                  </div>
                  <div className='RefundConfirmationViewMobile-secondWrapper-horizontalLine' />
                </>
              }
              { cardNumbers.map(cardNumber =>
                (
                  <div className='RefundConfirmationViewMobile-secondWrapper-fopDetails' key={ cardNumber }>
                    <p className='RefundConfirmationViewMobile-secondWrapper-fopDetails--cardDetails'><TranslatedCopy copyID='MYB_CARD' />{ ` ****${ cardNumber?.card }` }</p>
                    { cardNumber?.cardType === 'VI' &&
                      <Pictogram id='Visa' className='RefundConfirmationViewMobile-secondWrapper-fopDetails--cardLogo' />
                    }
                    { cardNumber?.cardType === 'CA' &&
                      <Pictogram id='Mastercard' className='RefundConfirmationViewMobile-secondWrapper-fopDetails--cardLogo' />
                    }
                    { cardNumber?.cardType === 'AX' &&
                      <Pictogram id='Amex' className='RefundConfirmationViewMobile-secondWrapper-fopDetails--amexLogo' />
                    }
                  </div>
                ))
              }
              <div className='RefundConfirmationViewMobile-secondWrapper-refundedAmount'>
                <TranslatedCopy
                  className='RefundConfirmationViewMobile-secondWrapper-refundedAmount--refundedHeader'
                  copyID='MYB_REFUNDED'
                  tagName='p'
                />
                <div className='RefundConfirmationViewMobile-secondWrapper-refundedAmount-details'>
                  <p className='RefundConfirmationViewMobile-secondWrapper-refundedAmount-details--amount'>
                    { `$${ formatAmountWithDecimals(total, decimals) }` }
                  </p>
                  <p className='RefundConfirmationViewMobile-secondWrapper-refundedAmount-details--currency'>{ currencyOfRefund }</p>
                </div>
              </div>
              <div className='RefundConfirmationViewMobile-secondWrapper-accountRedirectBtnContainer'>
                <TranslatedCopy
                  className='RefundConfirmationViewMobile-secondWrapper-accountRedirectBtnContainer--accountRedirectBtn'
                  copyID='MYB_EXIT_REFUND'
                  onClick={ () => window.location.href = HomeE4(language, country) }
                  tagName='button' />
              </div>
            </div>
            { showPoints &&
              <TranslatedCopy
                className='RefundConfirmationViewMobile-Body-confirmationViewUserDetails--note'
                copyID='MYB_USE_YOUR_BALANCE'
                tagName='p'
              />
            }
            <TranslatedCopy
              className='RefundConfirmationViewMobile-Body-confirmationViewUserDetails--note'
              copyID={ copyNote }
              tagName='p'
            />
          </div>
          <div className='RefundConfirmationViewMobile-Body-refundPaymentContainer'>
            <div className='RefundConfirmationViewMobile-Body-refundPaymentContainer-breakdownContainer'>
              <div className='RefundConfirmationViewMobile-refundToClientHeaderContainer'>
                <TranslatedCopy
                  className='RefundConfirmationViewMobile-refundToClientHeaderContainer--header'
                  copyID='MYB_REFUND_TO_CLIENT'
                  tagName='p' />
                <div className='RefundConfirmationViewMobile-refundToClientHeaderContainer-dateWrapper'>
                  <Pictogram className='RefundConfirmationViewMobile-refundToClientHeaderContainer-dateWrapper--calenderIcon' id='CalenderIcon' />
                  <p className='RefundConfirmationViewMobile-refundToClientHeaderContainer-dateWrapper--date'>{ date }</p>
                </div>
              </div>
              <RefundBreakdown
                breakpointNewDesign={ breakpointNewDesign }
                confirmation={ true }
              />
            </div>
          </div>
          { nonRefundableExtrasExist && 
            <div className='RefundConfirmationViewMobile-Body-extras'>
              <div className='RefundConfirmationViewMobile-Body-extras-container'>
                <Pictogram id='Clock' className='RefundConfirmationViewMobile-Body-extras-container--extrasIcon'/>
                <TranslatedCopy
                  className='RefundConfirmationViewMobile-Body-extras-container--ticketTitle'
                  copyID='MYB_PENDING_EXTRAS_EXIST'
                  tagName='p'
                />
              </div>
              { refundInfoToSalesforce?.loading ?
                <LoadingComponent
                  className='RefundConfirmationViewMobile-Body-extras-miniLoader'
                  refunds = { true }
                />
                :
                <>
                  { newTicketNumber !== 'Error' ?
                    <div className='RefundConfirmationViewMobile-Body-extras-ticketNumberContainer'>
                      <TranslatedCopy
                        className='RefundConfirmationViewMobile-Body-extras-ticketNumberContainer--ticketTitle'
                        copyID='MYB_TICKET'
                        tagName='p'
                      />
                      <p className='RefundConfirmationViewMobile-Body-extras-ticketNumberContainer--ticketText'>{ newTicketNumber }</p>
                    </div>
                    :
                    <TranslatedCopy
                      className='RefundConfirmationViewMobile-Body-extras--errorMessage'
                      copyID='MYB_THERE_WAS_AN_ERROR_NON_REFUNDABLE'
                      tagName='a'
                      onClick={ () => specialRefund(storefront, 'Reembolso no procesado ram') }
                    />
                  }
                </>
              }
            </div>
          }
          { penaltyChargeCard &&
            <RefundPenaltyChargePaid />
          }
          { thereAreDTickets &&
            <div className='RefundConfirmationViewMobile-Body-refundSuccessBottomSelection'>
              <TranslatedCopy
                className='RefundConfirmationViewMobile-Body-refundSuccessBottomSelection--text'
                copyID='MYB_THE_TICKETS_HAVE_BEEN_REFUNDED'
              />
              <TranslatedCopy
                className='RefundConfirmationViewMobile-Body-refundSuccessBottomSelection-buttonReload'
                copyID='MYB_RETURN_TO_REFUND_MY_FLIGHT'
                onClick={ () => window.location.reload() }
                tagName='button'
              />
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default RefundConfirmationViewMobile;